import React from 'react';
import PropTypes from 'prop-types';
import { loginAction, logoutAction } from './authActions';
import { authReducer, initialState } from './authReducer';

const AuthContext = React.createContext(null);
const authStorageKey = 'REACT-CHALLENGE-AUTH';

export const AuthProvider = ({ children, ...otherProps }) => {
  const [state, dispatch] = React.useReducer(authReducer, {
    ...initialState,
    user: localStorage.getItem(authStorageKey) ? JSON.parse(localStorage.getItem(authStorageKey)) : null,
  });
  const value = {
    ...state,
    login: loginAction(dispatch),
    logout: logoutAction(dispatch),
    isLoggedIn: Boolean(state.user),
  };

  React.useEffect(() => {
    if (state.user) {
      localStorage.setItem(authStorageKey, JSON.stringify(state.user));
    } else {
      localStorage.removeItem(authStorageKey);
    }
  }, [state.user]);

  function renderChildren() {
    if (typeof children === 'function') {
      return children(state);
    }
    return children;
  }

  return (
    <AuthContext.Provider {...otherProps} value={value}>
      {renderChildren()}
    </AuthContext.Provider>
  );
};

function useAuth() {
  return React.useContext(AuthContext);
}

AuthProvider.propTypes = {
  children: PropTypes.object,
};

export default useAuth;
